export default "__VITE_ASSET__cNM339aC__"